import {useMandantenHandling} from "../../hooks/mandanten/useMandantenHandling";
import Layout from "../../components/Layout";
import {Box, capitalize, DialogActions, DialogContent, Paper, Typography} from "@mui/material";
import {mandantenStyles} from "../../styles/mandanten/mandanten.styles";
import {Form, Formik, FormikProps} from "formik";
import {Mandant} from "../../api";
import FieldsContentMandant from "../../components/mandanten/FieldsContentMandant";
import SubmitButton from "../../components/SubmitButton";
import {useMandantUpdateForm} from "../../hooks/mandanten/useMandantUpdateForm";
import {useMandant} from "../../client/queries";
import {useParams} from "react-router";
import ErrorAlert from "../../components/ErrorAlert";
import {notPermitted} from "../../errors";
import MultipleGuard from "../../components/guards/MultipleGuard";
import {permissions} from "../../permissions";
import Guard from "../../components/guards/Guard";
import ButtonDeleteMandant from "../../components/mandanten/ButtonDeleteMandant";
import type { MandantFormValues } from "../../types/mandantenTypes";
import TableFreedays from "../../components/freedays/table/TableFreedays";
import TableSchedulers from "../../components/schedulers/table/TableSchedulers";

export default function PageUpdateMandant() {
    const {mandantId = ""} = useParams<{
        mandantId: string;
    }>();
    const {translation, canEditMandantField} = useMandantenHandling();
    const mandant: Mandant = useMandant(mandantId);
    const formikProps = useMandantUpdateForm(mandant);

    return (
        <Layout
            title={capitalize(translation('client-edit'))}
            back={"/mandanten"}
        >
            <MultipleGuard
                permissions={[
                    permissions.mandanten.edit,
                    permissions.mandanten.own_edit,
                    permissions.mandanten.show,
                    permissions.mandanten.own_show,
                ]}
                fallback={<ErrorAlert error={notPermitted()}/>}
            >
                <Paper id={'page-update-mandant-paper'}
                       elevation={1}
                       sx={mandantenStyles.pageUpdateMandant.paper}
                >
                    <Formik {...formikProps}>
                        {({isSubmitting, isValidating, isValid, dirty}: FormikProps<MandantFormValues>) => (
                            <Form id={'form-update-mandant'}>
                                <Box sx={mandantenStyles.pageUpdateMandant.headerBoxWrapper}>
                                    <Typography variant="h5">
                                        {capitalize(translation('client-edit'))}
                                    </Typography>
                                    <Guard
                                        permission={permissions.mandanten.delete}
                                    >
                                        <ButtonDeleteMandant mandantId={mandantId}/>
                                    </Guard>
                                </Box>
                                <DialogContent id={'page-update-mandant-dialog-content'}>
                                    <FieldsContentMandant canEditFields={canEditMandantField(mandantId)} mandant={mandant}/>
                                </DialogContent>
                                <DialogActions id={'page-update-mandant-dialog-actions'}>
                                    <SubmitButton id={'page-update-mandant-submit-button'}
                                                  form={'form-update-mandant'}
                                                  type={'submit'}
                                                  variant={'contained'}
                                                  color={'secondary'}
                                                  loading={isSubmitting}
                                                  disabled={isValidating
                                                      || !isValid
                                                      || !dirty
                                                      || !canEditMandantField(mandantId)}
                                    >
                                        {isSubmitting ? capitalize(translation('updating')) : capitalize(translation('update'))}
                                    </SubmitButton>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </Paper>
                <MultipleGuard permissions={[permissions.freedays.list, permissions.freedays.own_list]}>
                    <TableFreedays mandantId={mandantId}/>
                </MultipleGuard>
                <MultipleGuard permissions={[permissions.schedulers.list, permissions.schedulers.own_list]}>
                    <TableSchedulers mandantId={mandantId} embedded={true}/>
                </MultipleGuard>
            </MultipleGuard>
        </Layout>
    );
}